import React from 'react'
import { ImagesFormData } from '../../models/images'
import { Box, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useStyles } from 'src/Libs/installation-statement/components/Images/ImageUpload'

interface Props {
  data: ImagesFormData
}

const Images: React.FC<Props> = ({ data }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <Box>
      <Typography variant="h4">{t('installation-statement.images.title')}</Typography>
      <Box display="flex" gap={4} sx={{ mt: 2 }}>
        {(Object.keys(data.images) as Array<keyof typeof data.images>).map(type => (
          <Box key={type}>
            {data.images[type].previewUrl && <img src={data.images[type].previewUrl} alt={`${type}-preview`} className={classes.imagePreview} />}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default Images
